const debouncePromise = fn => {
  if (typeof fn !== 'function') {
    throw new Error('receive invalid function for debouncePromise')
  }

  let promiseProcess

  return (...args) => {
    if (!promiseProcess) {
      promiseProcess = Promise.resolve(fn(...args)).then(
        data => {
          promiseProcess = null
          return data
        },
        err => {
          promiseProcess = null
          throw err
        }
      )
    }

    return promiseProcess
  }
}

const createTimeoutPromise = (
  callback,
  timeout = 10000,
  debugFlag = '',
  timeoutToReject = true
) => {
  return new Promise((_resolve, _reject) => {
    let timer = null
    let done = false

    const teardown = () => {
      if (timer) {
        clearTimeout(timer)
        timer = null
      }
      done = true
    }

    const resolve = payload => {
      if (!done) {
        _resolve(payload)
      }
      teardown()
    }

    const reject = err => {
      if (!done) {
        _reject(err)
      }
      teardown()
    }

    callback(resolve, reject)

    timer = setTimeout(() => {
      if (timeoutToReject) {
        const errorMsg = debugFlag
          ? `Promise for "${debugFlag}" exceed timeout of ${timeout} ms`
          : `Promise exceed timeout of ${timeout} ms`

        reject(new Error(errorMsg))
      } else {
        resolve()
      }
    }, timeout)
  })
}

export {
  createTimeoutPromise,
  debouncePromise,
}